export function normalizeStringLength(length) {
    let parsedUnit = length.match(/px|em|%|rem|ratio|fr/);
    let parsedValue = parseFloat(length);
    const parsedRatio = length === null || length === void 0 ? void 0 : length.match(/\s*([\d+.]+)\s*:\s*([\d+.]+)\s*/);
    if (parsedRatio) {
        const ratio = parseFloat(parsedRatio[1]) / parseFloat(parsedRatio[2]);
        if (!Number.isNaN(ratio)) {
            return { value: ratio, unit: 'ratio' };
        }
    }
    let unit = 'px';
    let value = 0;
    if (parsedUnit) {
        unit = parsedUnit[0];
    }
    if (!Number.isNaN(parsedValue)) {
        value = parsedValue;
    }
    return { value, unit };
}
export function resolveLength(length, base) {
    if (length.unit == '%')
        return (length.value / 100) * base;
    return length.value;
}
export function stringifyLength(length, defaultValue = '0px') {
    var _a;
    if (length && typeof length == 'object') {
        // Skip NaNs
        if (parseInt(String(length.value)) !== parseInt(String(length.value))) {
            return defaultValue;
        }
        if ((_a = length.unit) === null || _a === void 0 ? void 0 : _a.match(/%|ratio|em|px|em|rem|fr|vmax|vmin|vw|vh/))
            return length.value + length.unit;
        return length.value + 'px';
    }
    if (typeof length == 'string' && length.match(/%|ratio|em|px|em|rem|fr|vmax|vmin|vw|vh/)) {
        return length;
    }
    if (length == null) {
        return defaultValue;
    }
    return length + 'px';
}
export const Length = (length) => {
    if (typeof length === 'string') {
        return normalizeStringLength(length);
    }
    if (typeof length === 'number') {
        return { value: normalizeStringLength(`${length}px`).value, unit: 'px' };
    }
    if (length && (length.value || length.unit)) {
        return normalizeStringLength(`${length.value}${length.unit}`);
    }
    return { value: 0, unit: 'px' };
};
export const NullLength = (length) => {
    if (length === '' || length == null || (length === null || length === void 0 ? void 0 : length.value) === null) {
        return null;
    }
};
export const pickFirst = (object, value) => {
    if (object === undefined && value !== undefined) {
        return value;
    }
    return object;
};
export const pickNonEmpty = (object, value) => {
    if (!(object instanceof Array) || object.length == 0) {
        return value;
    }
    return object;
};
export function LengthOrPosition(value) {
    switch (value) {
        case 'left':
        case 'top':
            var nextValue = '0%';
            break;
        case 'right':
        case 'bottom':
            var nextValue = '100%';
            break;
        case null:
        case undefined:
        case 'center':
            var nextValue = '50%';
    }
    return Length(nextValue !== null && nextValue !== void 0 ? nextValue : value);
}
//# sourceMappingURL=length.js.map